import React from 'react';
import * as PropTypes from 'prop-types';
import { ElementWrapper, Image, LineHeader, TitleText } from './elements';

type Props = {
  className?: string;
  imageUrl: string;
  title: string;
};

function InsightsHeader(props: Props): React.ReactElement {
  return (
    <ElementWrapper className={props.className}>
      <Image src={props.imageUrl} />
      <LineHeader>
        <TitleText>{props.title}</TitleText>
      </LineHeader>
    </ElementWrapper>
  );
}

InsightsHeader.propTypes = {
  className: PropTypes.string,
  imageUrl: PropTypes.string,
  title: PropTypes.string,
};

export default InsightsHeader;
